console.log('🔥 [APP.JS] TOP OF MODULE - imports about to execute');

import {preprocessAndLoadCss} from '../utils/lib';
import Localization from '../utils/Localization';
import InitialOptions from '../utils/InitialOptions';
import OS from '../tablet/OS';
import IO from '../tablet/IO';
import MediaLib from '../tablet/MediaLib';

console.log('🔥 [APP.JS] Core imports done');

import {indexMain} from './index';
import {homeMain} from './home';
import {editorMain} from './editor';
import {gettingStartedMain} from './gettingstarted';
import {inappInterfaceGuide, inappAbout, inappBlocksGuide, inappPaintEditorGuide} from './inapp';

console.log('🔥 [APP.JS] ALL imports done - module code executing');
// Expose core modules for template scripts that need to bind after bundle
try { if (typeof window !== 'undefined') { window.Localization = Localization; } } catch (_) {}

function loadSettings (settingsRoot, whenDone) {
    console.log('🔧 [APP.JS] loadSettings: Starting to load settings.json from', settingsRoot);
    IO.requestFromServer(settingsRoot + 'settings.json', (result) => {
        console.log('🔧 [APP.JS] loadSettings: Settings loaded successfully');
        window.Settings = JSON.parse(result);
        console.log('🔧 [APP.JS] loadSettings: Calling whenDone callback');
        whenDone();
    });
}

// App-wide entry-point
function initializeApp() {
    console.log('🚀 [APP.JS] initializeApp called! Page:', window.scratchJrPage);

    // Function to be called after settings, locale strings, and Media Lib
    // are asynchronously loaded. This is overwritten per HTML page below.
    let entryFunction = () => {};

    // Root directory for includes. Needed in case we are in the inapp-help
    // directory (and root becomes '../')
    let root = './';

    // scratchJrPage is defined in the HTML pages
    let page = window.scratchJrPage;
    console.log('🚀 [APP.JS] Detected page:', page);

    // Load CSS and set root/entryFunction for all pages
    switch (page) {
    case 'index':
        // Index page (splash screen)
        preprocessAndLoadCss('css', 'css/font.css');
        preprocessAndLoadCss('css', 'css/base.css');
        preprocessAndLoadCss('css', 'css/start.css');
        preprocessAndLoadCss('css', 'css/thumbs.css');
        /* For parental gate. These CSS properties should be refactored */
        preprocessAndLoadCss('css', 'css/editor.css');
        entryFunction = () => OS.waitForInterface(indexMain);
        break;
    case 'home':
        // Lobby pages
        console.log('🏠 [APP.JS] Loading home page CSS and entry function');
        preprocessAndLoadCss('css', 'css/font.css');
        preprocessAndLoadCss('css', 'css/base.css');
        preprocessAndLoadCss('css', 'css/lobby.css');
        preprocessAndLoadCss('css', 'css/thumbs.css');
        entryFunction = () => {
            console.log('🏠 [APP.JS] entryFunction called - waiting for OS interface before homeMain');
            OS.waitForInterface(homeMain);
        };
        break;
    case 'editor':
        // Editor pages
        preprocessAndLoadCss('css', 'css/font.css');
        preprocessAndLoadCss('css', 'css/base.css');
        preprocessAndLoadCss('css', 'css/editor.css');
        preprocessAndLoadCss('css', 'css/editorleftpanel.css');
        preprocessAndLoadCss('css', 'css/editorstage.css');
        preprocessAndLoadCss('css', 'css/editormodal.css');
        preprocessAndLoadCss('css', 'css/librarymodal.css');
        preprocessAndLoadCss('css', 'css/paintlook.css');
        entryFunction = () => OS.waitForInterface(editorMain);
        break;
    case 'gettingStarted':
        // Getting started video page
        preprocessAndLoadCss('css', 'css/font.css');
        preprocessAndLoadCss('css', 'css/base.css');
        preprocessAndLoadCss('css', 'css/gs.css');
        // Reuse gallery/thumb visuals for sample cards shown under the video
        // (minimal dependency; no lobby chrome/styles are pulled in)
        preprocessAndLoadCss('css', 'css/thumbs.css');
        entryFunction = () => OS.waitForInterface(gettingStartedMain);
        break;
    case 'inappAbout':
        // About Bluux in-app help frame
        preprocessAndLoadCss('style', 'style/about.css');
        // Content is authored statically in HTML to avoid localization-key flashes
        entryFunction = () => {};
        root = '../';
        break;
    case 'inappPrivacy':
        // Privacy Policy in-app page (styled like About, static content)
        preprocessAndLoadCss('style', 'style/about.css');
        // No dynamic localization injection required; content is static in HTML
        entryFunction = () => {};
        root = '../';
        break;
    case 'inappTerms':
        // Terms of Service in-app page (styled like About, static content)
        preprocessAndLoadCss('style', 'style/about.css');
        entryFunction = () => {};
        root = '../';
        break;
    case 'inappInterfaceGuide':
        // Interface guide in-app help frame
        preprocessAndLoadCss('style', 'style/style.css');
        preprocessAndLoadCss('style', 'style/interface.css');
        entryFunction = () => inappInterfaceGuide();
        root = '../';
        break;
    case 'inappPaintEditorGuide':
        // Paint editor guide in-app help frame
        preprocessAndLoadCss('style', 'style/style.css');
        preprocessAndLoadCss('style', 'style/paint.css');
        entryFunction = () => inappPaintEditorGuide();
        root = '../';
        break;
    case 'inappBlocksGuide':
        // Blocks guide in-app help frame
        preprocessAndLoadCss('style', 'style/style.css');
        preprocessAndLoadCss('style', 'style/blocks.css');
        entryFunction = () => inappBlocksGuide();
        root = '../';
        break;
    }

    // Start up sequence
    // Load settings from JSON
    console.log('📋 [APP.JS] Starting initialization sequence - calling loadSettings');
    loadSettings(root, () => {
        console.log('🌍 [APP.JS] Settings loaded - calling Localization.includeLocales');
        // Load locale strings from JSON
        Localization.includeLocales(root, () => {
            console.log('📚 [APP.JS] Locales loaded - calling MediaLib.loadMediaLib');
            // Load Media Lib from JSON
            MediaLib.loadMediaLib(root, () => {
                console.log('🎨 [APP.JS] MediaLib loaded - calling entryFunction for page:', page);
                // Expose MediaLib to window for global access
                window.MediaLib = MediaLib;
                console.log('🎨 [APP.JS] MediaLib.samples:', window.MediaLib && window.MediaLib.samples);

                // Note: Do not seed starters/samples on home/index; use Samples tab flow

                entryFunction();
            });
        });
        // Initialize currentUsage data
        console.log('⚙️ [APP.JS] Initializing currentUsage with Settings.initialOptions');
        InitialOptions.initWithSettings(window.Settings.initialOptions);
    });
}

// MICROSOFT PARTNER-LEVEL SOLUTION: Just initialize synchronously!
// The script tag is at the END of <body>, so DOM is ready when this executes.
// No setTimeout, no event listeners, no complexity.

console.log('🚀 [APP.JS] Module loaded - calling initializeApp() IMMEDIATELY');
console.log('🔍 [APP.JS] document.readyState:', document.readyState);
console.log('🔍 [APP.JS] window.scratchJrPage:', window.scratchJrPage);

// Just do it!
initializeApp();
